import { render, staticRenderFns } from "./WebPlayer.vue?vue&type=template&id=36fdab83&scoped=true&"
import script from "./WebPlayer.vue?vue&type=script&lang=js&"
export * from "./WebPlayer.vue?vue&type=script&lang=js&"
import style0 from "./WebPlayer.vue?vue&type=style&index=0&id=36fdab83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fdab83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36fdab83')) {
      api.createRecord('36fdab83', component.options)
    } else {
      api.reload('36fdab83', component.options)
    }
    module.hot.accept("./WebPlayer.vue?vue&type=template&id=36fdab83&scoped=true&", function () {
      api.rerender('36fdab83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/lib/components/WebPlayer.vue"
export default component.exports